import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewReceivedNotification from "../../components/Admin Notification/ViewReceivedNotification"; // This is the inner component

const ViewReceivedNotificationPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb
        id="title"
        title2="My Notification"
        link2="/mynotification"
        title="View MY Notification"
      />
      <ViewReceivedNotification /> {/* Inner component renders the notification details */}
    </MasterLayout>
  );
};

export default ViewReceivedNotificationPage;
